/**
 * @generated SignedSource<<4366d4611b052f2879a0efb4121d4b6c>>
 * @relayHash aece49299bfdf7c588a91a4e3fffc7ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 468331d6da43cc22e122d284e742f789659722e3ddbf8222f5a1a85d445641ba

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainHorizontalNavCsmSupportWebsiteQuery } from './mainHorizontalNavCsmSupportWebsiteQuery.graphql';

const node: PreloadableConcreteRequest<mainHorizontalNavCsmSupportWebsiteQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "468331d6da43cc22e122d284e742f789659722e3ddbf8222f5a1a85d445641ba",
    "metadata": {},
    "name": "mainHorizontalNavCsmSupportWebsiteQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
